import { OfferingModel, OnboardingConfigModel, OfferingsMetaConfigModel, OfferingMetaConfigItem } from "../../../../../../models/onboarding/onboarding.models";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { NotificationClientService, NotificationType } from "../../../../../../services/basics/notification-client.service";
import { ChildComponent } from "../../../../modules/child-component";
import { I18N } from "aurelia-i18n";
import { ArrayUtils } from "../../../../../../utilities/arrays";
import { transient, autoinject } from "aurelia-dependency-injection";
import { PropertyMetaModel } from "../../../../../../models/basics/basics.models";
import { FileHelper } from "../../../../../../helpers/file-helper";
import { useView } from "aurelia-framework";

@autoinject()
@transient()
@useView('views/pages/admin/onboarding/steps/onboarding-offerings/onboarding-offerings.html')
export class OnboardingOfferings extends ChildComponent<OnboardingConfigModel> {

    private _editorVMPath = 'views/pages/admin/onboarding/steps/onboarding-offerings/onboarding-offering-editor';

    public offeringConfigMetaPath: string;
    public offeringsMetaConfig: OfferingsMetaConfigModel;
    public variables: PropertyMetaModel[] = [];
    public variablesForIfConditions: PropertyMetaModel[] = [];

    constructor(private dialogClientService: DialogClientService,
        notificationService: NotificationClientService, i18N: I18N) {
        super(notificationService, i18N);
    }

    activate(model: { item: OnboardingConfigModel, variables: PropertyMetaModel[], variablesForIfConditions: PropertyMetaModel[], offeringConfigMetaPath: string }) {
        super.activate(model.item);
        this.variables = model.variables;
        this.variablesForIfConditions = model.variablesForIfConditions;
        this.offeringConfigMetaPath = model.offeringConfigMetaPath;

        this.offeringsMetaConfig = model.item.offeringsMetaConfig && model.item.offeringsMetaConfig.length > 0
            ? JSON.parse(model.item.offeringsMetaConfig)
            : {};

        if (!this.offeringsMetaConfig.items || this.offeringsMetaConfig.items.length == 0) {
            this.newOfferingMeta();
        }
    }

    getRankText(offering: OfferingModel) {
        if (offering.rank) {
            return offering.name + " (" + this.i18N.tr("rank-text") + " " + offering.rank + ")";
        }
        else {
            return offering.name;
        }
    }

    edit(offering: OfferingModel) {
        this.dialogClientService.show(this._editorVMPath,
            {
                item: offering,
                pluginInternalName: this.item.onboardingPlugin.internalName,
                variables: this.variables,
                variablesForIfConditions: this.variablesForIfConditions,
                onboardingConfigId: this.item.onboardingConfigId,
                onSaved: this.onSaved,
                offeringConfigMetaPath: this.offeringConfigMetaPath
            });
    }

    removeOffering($event, offering: OfferingModel) {
        $event.stopPropagation();
        if (offering.offeringId <= 0) {
            const index = ArrayUtils.findIndex(this.item.offerings, x => x.offeringId == offering.offeringId);
            if (index > -1) {
                this.item.offerings.splice(ArrayUtils.findIndex(this.item.offerings, x => x.offeringId == offering.offeringId), 1);
            }
        } else {
            offering.isActive = false;
        }
    }

    removeOfferingMeta(offeringMetaConfig: OfferingMetaConfigItem) {
        if (!this.offeringsMetaConfig.items || !offeringMetaConfig) {
            return;
        }

        const index = this.offeringsMetaConfig.items.indexOf(offeringMetaConfig);

        if (index == -1) {
            return;
        }

        this.offeringsMetaConfig.items.splice(index, 1);
    }

    newOffering() {
        this.dialogClientService.show(this._editorVMPath,
            {
                item: null,
                pluginInternalName: this.item.onboardingPlugin.internalName,
                variables: this.variables,
                variablesForIfConditions: this.variablesForIfConditions,
                onboardingConfigId: this.item.onboardingConfigId,
                onSaved: this.onSaved,
                offeringConfigMetaPath: this.offeringConfigMetaPath
            }, false);
    }

    newOfferingMeta() {
        if (!this.offeringsMetaConfig.items) {
            this.offeringsMetaConfig.items = [];
        }

        this.offeringsMetaConfig.items.push(
            {
                title: undefined,
                icon: undefined,
                descriptionHtml: undefined,
            }
        );
    }

    onSaved = (offering: OfferingModel) => {
        this.dialogClientService.hide();
        this.notificationService.show(this.i18N.tr('offerings-saved-successfully-text'), "", NotificationType.Success);
        const index = ArrayUtils.findIndex(this.item.offerings, x => x.offeringId == offering.offeringId);
        if (index == -1) {
            this.item.offerings.push(offering);
        }
    }

    downloadDocument(offering: OfferingModel) {
        FileHelper.downloadFile(`/api/v1/OnboardingClient/DownloadOfferingDocument/${offering.offeringId}/${offering.name}`);
        event.stopPropagation();
    }
}
